import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        '\n  display: flex;\n  position: relative;\n  margin-bottom: 14px;\n\n  &:after {\n    content: "";\n    position: absolute;\n    left: 9px;\n    top: 26px;\n    width: 2px;\n    height: 10px;\n    background-color: ',
        ";\n  }\n\n  &:last-child:after {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { lightColors } from "../../theme";
export var TimelineContainer = styled.ul.withConfig({
    componentId: "sc-1a46d3f-0"
})(_templateObject());
export var TimelineEvent = styled.li.withConfig({
    componentId: "sc-1a46d3f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, $useDark = param.$useDark;
    return $useDark ? theme.colors.textSubtle : lightColors.textSubtle;
});
